import { render, staticRenderFns } from "./InstallerAssigneesField.vue?vue&type=template&id=1651dead"
import script from "./InstallerAssigneesField.vue?vue&type=script&lang=ts"
export * from "./InstallerAssigneesField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports